// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "rescript/lib/es6/caml.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Patch from "common/src/Patch.bs.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as Axis from "@visx/axis";
import * as Grid from "@visx/grid";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as Curve from "@visx/curve";
import * as Scale from "@visx/scale";
import * as Shape from "@visx/shape";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as LpChartUtils from "common/src/LpChartUtils.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as Caml_splice_call from "rescript/lib/es6/caml_splice_call.js";
import * as PlPlacesDistribution from "../player2/PlPlacesDistribution.bs.js";
import * as WrappedSectionHeader from "./WrappedSectionHeader.bs.js";

function WrappedPatchStats(Props) {
  var patchStats = Props.patchStats;
  var patches = Props.patches;
  var set = TftSet.use(undefined);
  var match = React.useState(function () {
        
      });
  var setHoverIdx = match[1];
  var hoverIdx = match[0];
  var screenSize = ScreenAtom.use(undefined);
  var chartData = Belt_Array.keepMap(patches, (function (p) {
          return Belt_Option.map(Belt_Option.flatMap(Js_dict.get(patchStats, String(p)), (function (ps) {
                            return ps.endRank;
                          })), (function (er) {
                        return [
                                p,
                                er
                              ];
                      }));
        }));
  if (chartData.length === 0) {
    return null;
  }
  Belt_Array.getExn(chartData, 0)[0];
  var bestPatch = Belt_Array.getExn(Belt_SortArray.stableSortBy(Belt_Array.map(Belt_Array.keep(Js_dict.entries(patchStats), (function (param) {
                        return Belt_Option.isSome(param[1].peakRank);
                      })), (function (param) {
                    return [
                            Belt_Option.getExn(Belt_Int.fromString(param[0])),
                            Belt_Option.getExn(param[1].peakRank)
                          ];
                  })), (function (param, param$1) {
                var match = param$1[1];
                var match$1 = param[1];
                return Caml.caml_int_compare(LpChartUtils.divisionToBase(match[0], set) + match[1] | 0, LpChartUtils.divisionToBase(match$1[0], set) + match$1[1] | 0);
              })), 0)[0];
  var selectedPatch = Belt_Option.getWithDefault(Belt_Option.map(hoverIdx, (function (idx) {
              return Belt_Array.getExn(chartData, idx)[0];
            })), bestPatch);
  var rawRanks = Belt_Array.map(Belt_Array.map(chartData, (function (prim) {
              return prim[1];
            })), (function (param) {
          return LpChartUtils.divisionToBase(param[0], set) + param[1] | 0;
        }));
  var minY = Caml_splice_call.spliceApply(Math.min, [rawRanks]);
  var maxY = Caml_splice_call.spliceApply(Math.max, [rawRanks]);
  var xScale = Scale.scaleLinear({
        domain: [
          0,
          Global.f(chartData.length - 1 | 0)
        ],
        range: [
          0,
          Global.f(335)
        ]
      });
  var xScaleRev = Scale.scaleLinear({
        range: [
          0,
          Global.f(chartData.length - 1 | 0)
        ],
        domain: [
          0,
          Global.f(335)
        ]
      });
  var yScale = Scale.scaleLinear({
        domain: [
          Global.f(minY),
          Global.f(maxY)
        ],
        range: [
          Global.f(230),
          0
        ]
      });
  var ps = Js_dict.get(patchStats, String(selectedPatch));
  var tmp;
  if (ps !== undefined) {
    var ps$1 = Caml_option.valFromOption(ps);
    var placements = ps$1.placements;
    var lpDelta = ps$1.lpDelta;
    var t1 = Belt_Array.keep(placements, (function (p) {
            return p === 1;
          })).length;
    Belt_Array.keep(placements, (function (p) {
            return p === 2;
          })).length;
    Belt_Array.keep(placements, (function (p) {
            return p === 3;
          })).length;
    Belt_Array.keep(placements, (function (p) {
            return p === 4;
          })).length;
    var t5 = Belt_Array.keep(placements, (function (p) {
            return p >= 5;
          })).length;
    var tot = placements.length;
    var top4 = Global.f(tot - t5 | 0) / Global.f(tot);
    var win = Global.f(t1) / Global.f(tot);
    var avg = Global.f(Belt_Array.reduce(placements, 0, (function (acc, v) {
                return acc + v | 0;
              }))) / Global.f(placements.length);
    var match$1 = ps$1.peakRank;
    tmp = React.createElement("div", {
          className: "flex flex-col items-center mt-[-28px] w-full text-sm"
        }, React.createElement("div", {
              className: "h-6 text-base text-primary-11 font-semibold"
            }, selectedPatch === bestPatch ? "Peak patch" : " "), React.createElement("div", {
              className: "flex w-full justify-between"
            }, React.createElement("div", undefined, React.createElement("div", {
                      className: "flex justify-between"
                    }, React.createElement("div", {
                          className: "wrapped-num text-primary-11"
                        }, Patch.render(selectedPatch))), React.createElement("div", {
                      className: "flex justify-between"
                    }, React.createElement("div", undefined, React.createElement("span", {
                              className: "font-montserrat font-semibold"
                            }, String(tot)), " games")), React.createElement("div", undefined, React.createElement("div", undefined, React.createElement("span", {
                              className: "font-montserrat font-semibold"
                            }, (
                              lpDelta > 0 ? "+" : ""
                            ) + String(lpDelta)), " LP"))), React.createElement("div", {
                  className: "flex flex-col items-end pl-2"
                }, React.createElement("div", {
                      className: "flex"
                    }, "Avg ", React.createElement("div", {
                          className: "w-[46px] text-right font-montserrat font-semibold"
                        }, Global.toFixed(undefined, avg))), React.createElement("div", {
                      className: "flex"
                    }, "Top4 ", React.createElement("span", {
                          className: "w-[46px] text-right font-montserrat font-semibold"
                        }, Global.formatPct(undefined, top4) + "%")), React.createElement("div", {
                      className: "flex"
                    }, "Win ", React.createElement("div", {
                          className: "w-[46px] text-right font-montserrat font-semibold"
                        }, Global.formatPct(undefined, win) + "%")))), match$1 !== undefined ? React.createElement("div", {
                className: "pt-2 mx-[-10px]"
              }, "Peak ", React.createElement("span", {
                    className: "font-montserrat font-semibold"
                  }, LpChartUtils.renderDivisionName(match$1[0]) + " " + String(match$1[1]) + "LP")) : null, React.createElement("div", undefined), React.createElement("div", {
              className: "pt-2 pb-2"
            }, React.createElement("div", {
                  className: "font-montserrat font-semibold text-primary-11 pb-1"
                }, "Top Carries"), React.createElement("div", {
                  className: "flex"
                }, Belt_Array.map(ps$1.carries, (function (unitId) {
                        return React.createElement("div", {
                                    className: "px-1"
                                  }, React.createElement(UnitImage.make, {
                                        unitId: unitId,
                                        size: 40
                                      }));
                      })))), React.createElement("div", {
              className: "ml-[-6px]"
            }, React.createElement(PlPlacesDistribution.Inner.make, {
                  places: placements,
                  chartHeight: 100,
                  barArea: 17,
                  doubleUp: false
                })));
  } else {
    tmp = React.createElement("div", {
          className: "flex flex-col items-center"
        }, React.createElement("div", undefined, Patch.render(selectedPatch)));
  }
  return React.createElement("div", {
              className: "pt-16"
            }, React.createElement(WrappedSectionHeader.make, {
                  title: "Your journey through patch notes"
                }), React.createElement("div", {
                  className: "flex justify-between"
                }, React.createElement("svg", {
                      className: "ml-[-10px]",
                      height: "290",
                      width: "405",
                      onMouseLeave: (function (param) {
                          return Curry._1(setHoverIdx, (function (param) {
                                        
                                      }));
                        }),
                      onMouseMove: (function (e) {
                          var left = e.nativeEvent.offsetX - 60 | 0;
                          var idx = Caml.caml_int_min(Caml.caml_int_max(Math.round(Curry._1(xScaleRev, Global.f(left))) | 0, 0), chartData.length - 1 | 0);
                          return Curry._1(setHoverIdx, (function (param) {
                                        return idx;
                                      }));
                        })
                    }, React.createElement("g", {
                          transform: "translate(14, 130)"
                        }, React.createElement("text", {
                              fill: "var(--white1)",
                              fontSize: "12px",
                              textAnchor: "middle",
                              transform: "rotate(-90)"
                            }, "Rank")), React.createElement("text", {
                          fill: "var(--white1)",
                          fontSize: "12px",
                          textAnchor: "middle",
                          x: "231",
                          y: "290"
                        }, "Patch"), React.createElement("g", {
                          transform: "translate(" + String(60) + ", " + String(20) + ")"
                        }, hoverIdx !== undefined ? React.createElement("line", {
                                stroke: "var(--white2)",
                                strokeDasharray: "6 4",
                                strokeWidth: "1.5",
                                x1: Global.toFixed(undefined, Curry._1(xScale, Global.f(hoverIdx))),
                                x2: Global.toFixed(undefined, Curry._1(xScale, Global.f(hoverIdx))),
                                y1: "0",
                                y2: Global.toFixed(undefined, Global.f(230))
                              }) : null, React.createElement(Grid.Grid, {
                              top: 0,
                              left: 0,
                              xScale: xScale,
                              yScale: yScale,
                              stroke: "rgba(255, 255, 255, 0.24)",
                              width: 335,
                              height: 230,
                              numTicksRows: 5,
                              numTicksColumns: 8
                            }), React.createElement(Axis.AxisLeft, {
                              top: 0,
                              left: 0,
                              scale: yScale,
                              numTicks: 5,
                              stroke: "white",
                              tickStroke: "white",
                              tickFormat: (function (v) {
                                  var match = LpChartUtils.ratingToDivision(v | 0, set);
                                  var lp = match[1];
                                  var div = match[0];
                                  if (div === "M" && lp !== 0) {
                                    return String(lp);
                                  } else {
                                    return div;
                                  }
                                }),
                              tickLabelProps: (function (param) {
                                  return LpChartUtils.tickLabelPropsLeft(screenSize, set, param);
                                })
                            }), React.createElement(Axis.AxisBottom, {
                              top: 230,
                              left: 0,
                              scale: xScale,
                              numTicks: 8,
                              stroke: "white",
                              tickValues: Belt_Array.map(Belt_Array.range(0, chartData.length - 1 | 0), Global.f),
                              tickStroke: "white",
                              tickFormat: (function (v) {
                                  return Patch.render(Belt_Array.getExn(chartData, v | 0)[0]).slice(2, 99);
                                }),
                              tickLabelProps: (function (param) {
                                  return LpChartUtils.tickLabelPropsBottom(screenSize, param);
                                })
                            }), React.createElement(Shape.LinePath, {
                              strokeWidth: 2,
                              data: chartData,
                              x: (function (param, idx) {
                                  return Curry._1(xScale, Global.f(idx) === 0 ? 0 : Global.f(idx));
                                }),
                              y: (function (param) {
                                  var match = param[1];
                                  return Curry._1(yScale, Global.f(LpChartUtils.divisionToBase(match[0], set) + match[1] | 0));
                                }),
                              stroke: "var(--primary-11)",
                              curve: Curve.curveCatmullRom
                            }), Belt_Array.mapWithIndex(chartData, (function (idx, param) {
                                var match = param[1];
                                var y = LpChartUtils.divisionToBase(match[0], set) + match[1] | 0;
                                return React.createElement("circle", {
                                            key: String(idx),
                                            cx: Global.toFixed(undefined, Curry._1(xScale, Global.f(idx))),
                                            cy: Global.toFixed(undefined, Curry._1(yScale, Global.f(y))),
                                            fill: "var(--white1)",
                                            r: "3.5"
                                          });
                              })))), React.createElement("div", {
                      className: "flex flex-col items-center font-montserrat font-medium text-sm leading-snug min-w-[176px]"
                    }, tmp)));
}

var make = WrappedPatchStats;

export {
  make ,
  
}
/* Patch Not a pure module */
